
export default function MoneyFormat (props)
{
    let value = props.value;
    
    //const neg = props.neg !== undefined && props.neg;
    let signSpan = (<></>);

    if (props.sign === undefined || props.sign)
    {
	if (value >= 0) signSpan = (<span>+</span>); else signSpan = (<span>-</span>);
	value = Math.abs(value);
    }

    value = value.toString();
    
    if (value.length > 3)
    {
	return (
	    <span className="d-inline-flex justify-content-center align-items-center gap-1">
		{props.withIcon && (<span>💰</span>)}
		{signSpan}
		<span>{value.substring(0, value.length-3)}</span>
		<span>{value.substring(value.length-3, value.length)}</span>
		<span>€</span>
	    </span>
	);
    }

    else return (
	<span className="d-inline-flex justify-content-center align-items-center gap-1">
	    {props.withIcon && (<span>💰</span>)}
	    {signSpan}
	    <span>{value}</span>
	    <span>€</span>
	</span>
    );
}
